import { ClickableList, Container, Row } from '@cdab/scania/qpr/components'
import { TdsBlock, TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledPaddingWrapper = styled.div`
  padding-bottom: 12px;
  padding-top: 12px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    padding-left: 12px;
  }
`

export const StyledContainer = styled(Container)`
  background: var(--tds-grey);
`

export const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`

export const StyledBlock = styled(TdsBlock)`
  height: 100%;
  overflow-x: scroll;
  padding: 0 !important;
  :first-child {
    padding: 0 !important;
  }
`

export const StyledClickableList = styled(ClickableList)`
  overflow: hidden;
`

export const StyledRow = styled(Row)`
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 8px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 8px;
    margin-bottom: 4px;
  }
`

export const StyledButtonsRow = styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 32px;
  @media (max-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 24px;
  }
`

export const StyledLastButtonWrapper = styled.div`
  flex: 1 0 30%;
  direction: rtl;
`

export const StyledFirstButton = styled(TdsButton)`
  padding-right: 8px;
`

export const Title = styled.h3.attrs({
  className: 'tds-headline-03'
})`
  margin-bottom: 8px;
  margin-top: 8px;
`
